import { Component } from "@angular/core";
import { FormField } from "src/app/interfaces/form-field.model";
import {
  faTrash,
  faSave,
  faPrint,
  faChain,
} from "@fortawesome/free-solid-svg-icons";
import { NotifierService } from "angular-notifier";
import { environment } from "src/environments/environment";
import { FormControl } from "@angular/forms";
import { PaymentStatusService } from "src/app/services/autopac/payment-status.service";
@Component({
  selector: "app-payment-status",
  templateUrl: "./payment-status.component.html",
  styleUrls: ["./payment-status.component.css"],
})
export class PaymentStatusComponent {
  selectedTab = "Balance";
  faTrash = faTrash;
  faPrint = faPrint;
  faSave = faSave;
  faChain = faChain;

  tableHeadersTotalAmountReceived = [
    { title: "RECEIPT NUMBER", type: "data", id: "ReceiptNumber" },
    { title: "RECEIPT DATE", type: "data", id: "ReceiptDate" },
    { title: "BANK", type: "data", id: "Bank" },
    { title: "CHEQUE NUMBER", type: "data", id: "ChequeNo" },
    { title: "POST DATED", type: "data", id: "PostDated" },
    { title: "AMOUNT", type: "data", id: "Amount" },
  ];

  allDataTotalAmountReceived: any[] = [];
  filteredDataTotalAmountReceived: any[] = [];

  tableHeadersChequesIssued = [
    { title: "CHEQUE NUMBER", type: "data", id: "CHEQUENO" },
    { title: "CHEQUE DATE", type: "data", id: "CHEQUEDATE" },
    { title: "CHEQUE AMOUNT", type: "data", id: "PAYAMOUNT" },
    { title: "PURPOSE", type: "data", id: "PURPOSE" },
    { title: "PAYEE", type: "data", id: "PAYTO" },
  ];

  allDataChequesIssued: any[] = [];
  filteredDataChequesIssued: any[] = [];

  tableHeadersKomocoItems = [
    { title: "ITEM", type: "data", id: "Name" },
    { title: "PRICE ($)", type: "data", id: "Value" },
  ];

  allDataKomocoItems: any[] = [];
  filteredDataKomocoItems: any[] = [];

  lastSearchResult: any = null;
  adjustmentHeaders = [
    { title: "Amount", type: "data", id: "Amount" },
    { title: "Date", type: "data", id: "DateCreated" },
    { title: "Reason", type: "data", id: "Category" },
  ];
  salesmanReceiptHeaders = [
    { title: "Receipt Number", type: "data", id: "ReceiptNumber" },
    { title: "Receipt Date", type: "data", id: "ReceiptDate" },
    { title: "Bank", type: "data", id: "Bank" },
    { title: "Cheque Number", type: "data", id: "ChequeNo" },
    { title: "Amount", type: "data", id: "Amount" },
    { title: "Status", type: "data", id: "Status" },
  ];

  constructor(
    private paymentStatusService: PaymentStatusService,
    private notifier: NotifierService,
  ) {}

  searchBooking: FormField[] = [
    {
      type: "text",
      id: "ContractNumber",
      label: "Contract Number",
    },
    {
      type: "text",
      id: "InvoiceNumber",
      label: "Invoice Number",
    },
    {
      type: "text",
      id: "RegistrationNumber",
      label: "Registration Number",
    },
    {
      type: "text",
      id: "NRICNumber",
      label: "NRIC",
    },
    {
      type: "text",
      id: "RefNo",
      label: "Buyer's Order Number",
    },
    {
      type: "text",
      id: "ChasisNumber",
      label: "Chasis Number",
    },
    {
      type: "text",
      id: "EngineNumber",
      label: "Engine Number",
    },
    /*{
      type: "search",
      id: "searchLocation",
      label: "Motor Number",
    },*/
  ];

  buyersDetailsForm!: FormField[];
  buyersDetails!: FormField[];
  buyersDetails2!: FormField[];
  detailsVehicle!: FormField[];
  detailsVehicle2!: FormField[];
  detailsVehicle3!: FormField[];
  detailsVehicle4!: FormField[];
  detailsCashDiscount!: FormField[];
  detailsDeposit!: FormField[];
  detailsOtherFees!: FormField[];
  detailsInsurance!: FormField[];
  detailsHireApplication!: FormField[];
  detailsTradeInVehicle!: FormField[];
  komocosAccount_Promotion!: FormField[];
  komocosAccount_Accessories!: FormField[];
  buyersAccount_NonAccessories!: FormField[];
  buyersAccount_Accessories!: FormField[];
  consultantAccount_NonAccessories!: FormField[];
  consultantAccount_Accessories!: FormField[];
  additionalRemarks!: FormField[];
  totalAmountReceivedForm!: FormField[];
  buyersDetailsSalesSummary!: FormField[];
  detailsVehicle5!: FormField[];

  searchByForm: FormField[] = [
    {
      type: "select",
      id: "searchBy",
      label: "Search by",
      options: [
        { value: "ContractNo", display: "Contract Number" },
        { value: "InvoiceNo", display: "Invoice Number" },
        { value: "RegNo", display: "Registration Number" },
        { value: "NRIC", display: "NRIC" },
        { value: "BuyerOrder", display: "Buyer's Order Number" },
        { value: "ChasisNumber", display: "Chasis Number" },
        { value: "EngineNumber", display: "Engine Number" },
      ],
      value: "ContractNo",
    },
    {
      type: "search",
      id: "searchText",
      label: "Text to search",
      searchEvent: true,
      searchType: "searchByField",
    },
  ];

  isSearching = false;
  isSaving = false;
  private version = 0;
  get busy(): boolean {
    return this.isSearching || this.isSaving;
  }
  get hasContract(): boolean {
    return !!this.lastSearchResult?.ContractNumber;
  }
  get formGroups(): Record<string, FormField[]> {
    return {
      searchByForm: this.searchByForm,
      searchBooking: this.searchBooking,
      buyersDetailsForm: this.buyersDetailsForm,
      buyersDetails: this.buyersDetails,
      buyersDetails2: this.buyersDetails2,
      detailsVehicle: this.detailsVehicle,
      detailsVehicle2: this.detailsVehicle2,
      detailsVehicle3: this.detailsVehicle3,
      detailsVehicle4: this.detailsVehicle4,
      detailsCashDiscount: this.detailsCashDiscount,
      detailsOtherFees: this.detailsOtherFees,
      detailsInsurance: this.detailsInsurance,
      detailsHireApplication: this.detailsHireApplication,
      detailsTradeInVehicle: this.detailsTradeInVehicle,
      additionalRemarks: this.additionalRemarks,
      totalAmountReceivedForm: this.totalAmountReceivedForm,
      buyersDetailsSalesSummary: this.buyersDetailsSalesSummary,
      detailsVehicle5: this.detailsVehicle5,
    };
  }
  updateFields(event: any): void {
    if (!this.formGroups[event.name]) return;
    (this as any)[event.name] = event.fields;
    const field = event.fields[event.updatedValue];
    if (
      !field ||
      event.name === "searchByForm" ||
      event.name === "searchBooking" ||
      !this.lastSearchResult ||
      field.lock
    )
      return;
    if (field.id === "ProceedToChequeIssue") {
      this.proceedToChequeIssue(field);
      return;
    }
    this.lastSearchResult[field.id] = this.apiValue(field);
    this.synchronizeFields(field.id);
    // Match V1's current behavior: edits change inputs, not loaded totals.
    // Totals are refreshed only from Search after an explicit save or search.
  }
  updateHireField(field: FormField, value: any): void {
    field.value = value;
    this.updateFields({
      name: "detailsTradeInVehicle",
      fields: this.detailsTradeInVehicle,
      updatedValue: this.detailsTradeInVehicle.indexOf(field),
    });
  }
  private apiValue(field: FormField): any {
    if (field.type === "number")
      return field.value === "" || field.value == null
        ? null
        : Number(field.value);
    if (field.type === "date")
      return field.value
        ? String(field.value).split("-").reverse().join("/")
        : "";
    if (field.type === "formCheckboxSingle") return !!field.value;
    return field.value == null ? "" : field.value;
  }
  preserveZero(event: Event): void {
    const input = event.target as HTMLInputElement;
    if (
      input.type !== "number" ||
      input.value === "" ||
      Number(input.value) !== 0
    )
      return;
    const id = input.closest("app-text-input")?.id;
    for (const [name, fields] of Object.entries(this.formGroups)) {
      const index = (fields || []).findIndex(
        (field) => field.id === id && !field.lock,
      );
      if (index < 0) continue;
      fields[index].value = 0;
      this.updateFields({ name, fields, updatedValue: index });
      return;
    }
  }
  ngOnInit(): void {
    this.selectedTab = "Balance";
    this.buyersDetailsForm = [
      {
        type: "text",
        id: "ContractDate",
        label: "Contract Date",
        lock: true,
      },
      {
        type: "text",
        id: "RegistrationDate",
        label: "Registration Date",
        lock: true,
      },
      {
        type: "text",
        id: "VINNumber",
        label: "VIN Number",
        lock: true,
      },
      {
        type: "text",
        id: "ChasisNumber",
        label: "Chasis Number",
        lock: true,
      },
      { type: "text", id: "Model", label: "Model", lock: true },
      { type: "text", id: "Colour", label: "Colour", lock: true },
      { type: "text", id: "COEType", label: "COE Type", lock: true },
      { type: "text", id: "CarType", label: "Car Type", lock: true },
      {
        type: "text",
        id: "SalesConsultant",
        label: "Sales Consultant",
        lock: true,
      },
      {
        type: "text",
        id: "FinanceReceiptDate",
        label: "Finance Receipt Date",
        lock: true,
      },
      {
        type: "text",
        id: "FinanceReceiptNumber",
        label: "Finance Receipt Number",
        lock: true,
      },
      {
        type: "text",
        id: "BuyerName",
        label: "Buyer's Name",
        lock: true,
      },
      {
        type: "text",
        id: "SpotterCommission",
        label: "Spotter's Commission",
        lock: true,
      },
      {
        type: "text",
        id: "Overtrade",
        label: "Komoco Overtrade Subsidy ($)",
        lock: true,
      },
      { type: "textarea", id: "Remarks", label: "Remarks" },
    ];
    this.buyersDetails = [
      {
        type: "const",
        id: "TotalAmountInSalesConsultantAccount",
        label: "Total Amount In Sales Consultant's Account:",
      },
    ];
    this.buyersDetails2 = [
      {
        type: "const",
        id: "totalAmountReceived:",
        label: "Total Amount Received:",
      },
    ];
    this.detailsVehicle = [
      {
        type: "const",
        id: "TotalAmountInBuyerAccount",
        label: "Total Amount In Buyer's Account:",
        //value: 6,
      },
    ];
    this.detailsVehicle2 = [
      {
        type: "date",
        id: "PARFReceivedDate",
        required: true,
        label: "PARF Received Date",
      },
      {
        type: "number",
        id: "PARFValue",
        label: "PARF Value",
      },
      {
        type: "date",
        id: "SettlementInstructionToAC",
        required: true,
        label: "Settlement Instruction to A/c",
      },
      {
        type: "number",
        id: "COERebateValue",
        label: "COE Rebate Value",
      },
    ];
    this.detailsVehicle3 = [
      {
        type: "number",
        id: "InsurancePremium",
        label: "Insurance Premium",
      },
      {
        type: "select",
        id: "InsuranceCompany",
        label: "Insurance Company",
        options: [],
      },
      {
        type: "number",
        id: "FirstInstallment",
        label: "First Installment",
      },
      {
        type: "text",
        id: "FinanceCompany",
        lock: true,
        label: "Finance Company",
      },
      {
        type: "number",
        id: "AdministrativeCharge",
        label: "Administrative Charge",
      },
      {
        type: "formCheckboxSingle",
        lock: true,
        id: "ProceedToChequeIssue",
        label: "Proceed to Cheque Issue",
      },
    ];
    this.detailsVehicle4 = [
      {
        type: "const",
        id: "totalAmountInBuyerAccount:",
        label: "Total Amount In Buyer's Account:",
        //value: 0,
      },
    ];
    this.detailsCashDiscount = [
      {
        type: "number",
        id: "VehiclePrice",
        lock: true,
        label: "Vehicle Price",
      },
      {
        type: "number",
        id: "COETopUp",
        label: "COE Top Up",
      },
      {
        type: "number",
        id: "CEVSSurcharge",
        label: "CEVS/VES Surcharge",
      },
      {
        type: "number",
        id: "AdditionalRoadTax",
        lock: true,
        label: "Additional Road Tax",
      },
      {
        type: "number",
        id: "Accessories",
        lock: true,
        label: "Accessories",
      },
      {
        type: "number",
        id: "NumberRetentionFee",
        label: "Number Retention Fee",
      },
      {
        type: "const",
        id: "TotalDueAmount",
        label: "Total Due Amount:",
      },
    ];
    this.detailsOtherFees = [
      {
        type: "number",
        id: "CashDiscount",
        label: "Cash Discount",
      },
      {
        type: "number",
        id: "OPCRebate",
        label: "OPC Rebate",
      },
      {
        type: "number",
        id: "COERebate",
        label: "COE Rebate",
      },
      {
        type: "number",
        id: "ARFRebate",
        label: "ARF Rebate",
      },
      {
        type: "number",
        id: "DutyRebate",
        label: "Duty Rebate",
      },
    ];
    this.detailsInsurance = [
      {
        type: "number",
        id: "PARFRebate",
        label: "PARF Rebate",
      },

      {
        type: "number",
        id: "COEResidualRebate",
        label: "COE Residual Rebate",
      },
    ];
    this.detailsHireApplication = [
      {
        type: "const",
        id: "TotalRebateAmount",
        label: "Total Rebate Amount:",
      },
      {
        type: "const",
        id: "TotalDueAmountAfterRebates",
        label: "Total Due Amount (after rebates):",
      },
    ];
    this.detailsTradeInVehicle = [
      {
        type: "select",
        id: "FinCompany",
        label: "Finance Company",
        options: [],
      },
      /*{
        type: "const",
        id: "",
        label: " ",
      },*/
      {
        type: "number",
        id: "LoanPeriod",
        lock: true,
        label: "Loan Period",
      },
      /*{
        type: "const",
        id: "",
        label: " ",
      },*/
      {
        type: "number",
        id: "LoanRate",
        lock: true,
        label: "Loan Rate",
      },
      /*{
        type: "const",
        id: "",
        label: " ",
      },*/
      {
        type: "number",
        id: "LoanAmount",
        label: "Loan Amount",
      },
    ];

    this.additionalRemarks = [
      {
        type: "const",
        id: "Status",
        label: "Status:",
      },
      {
        type: "const",
        id: "AdjustmentAmount",
        label: "Adjustment Amount:",
      },
      {
        type: "const",
        id: "BalanceAmount",
        label: "Balance Amount:",
      },
      {
        type: "const",
        id: "FinalBalance",
        label: "Final Balance:",
      },
    ];

    this.totalAmountReceivedForm = [
      {
        type: "const",
        id: "TotalAmountReceived",
        label: "Total Amount Received: ($)",
      },
    ];

    this.detailsVehicle5 = [
      {
        type: "const",
        id: "TotalAmountInKomocoAccount",
        label: "Total Amount In Komoco's Account:",
      },
    ];

    this.buyersDetailsSalesSummary = [
      {
        type: "const",
        id: "TotalAmountReceivedSalesConsultant",
        label: "Total Amount Received:",
      },
      { type: "const", id: "FinalExcess", label: "Final Excess" },
    ];

    for (const fields of Object.values(this.formGroups))
      for (const field of fields || []) {
        if (field.type === "number") field.step = 0.01;
      }
    this.clear();
    this.paymentStatusService.getAllFinanceManagers().subscribe({
      next: (res) => {
        const financeManagers = Array.isArray(res?.body)
          ? res.body
          : [];

        const financeOptions = financeManagers.map(
          (manager: any) => ({
            display: manager.AcFullName,
            value: manager.AcCode,
          }),
        );

        // NO FINANCE - CASH PAYMENT at the top
        financeOptions.unshift({
          display: "NO FINANCE - CASH PAYMENT",
          value: "NF",
        });

        const financeField = this.detailsTradeInVehicle.find(
          (f) => f.id === "FinCompany",
        );
        if (financeField) {
          financeField.options = financeOptions;
        }
      },
      error: (err) => {
        console.error("Error fetching finance managers:", err);
        this.reportError(err);
      },
    });

    this.paymentStatusService.getActiveInsuranceList().subscribe({
      next: (res) => {
        const insuranceList = Array.isArray(res?.body)
          ? res.body
          : [];

        const insuranceOptions = insuranceList.map((item: any) => ({
          display: item.Name,
          value: item.Value,
        }));

        const insuranceField = this.detailsVehicle3.find(
          (f) => f.id === "InsuranceCompany",
        );
        if (insuranceField) {
          insuranceField.options = insuranceOptions;
        }
      },
      error: (err) => {
        console.error("Error fetching insurance list:", err);
        this.reportError(err);
      },
    });
  }

  private reportError(error: any): void {
    this.notifier.notify(
      "error",
      error?.message || "The operation was not completed",
    );
  }
  private succeeded(response: any): boolean {
    if (
      response?.code === 0 &&
      response.statusCode >= 200 &&
      response.statusCode < 300
    )
      return true;
    this.reportError(response);
    return false;
  }
  private buildModel(): any {
    return JSON.parse(JSON.stringify(this.lastSearchResult));
  }
  private synchronizeFields(onlyId?: string): void {
    for (const [name, fields] of Object.entries(this.formGroups)) {
      if (name === "searchByForm") continue;
      for (const field of fields || []) {
        if (onlyId && field.id !== onlyId) continue;
        const id =
          field.id === "FinalExcess" ? "BalancePayment" : field.id;
        const raw = this.lastSearchResult?.[id];
        if (field.type === "date") {
          const match = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(raw || "");
          field.value = match
            ? match[3] + "-" + match[2] + "-" + match[1]
            : "";
        } else field.value = raw;
        if (field.id === "FinalExcess")
          field.label =
            this.lastSearchResult?.SalesmanPaymentStatus ||
            "Balance Payment";
        if (field.id === "ProceedToChequeIssue")
          field.lock =
            !this.hasContract ||
            this.lastSearchResult?.EnableProceedToChequeIssue ===
              false;
      }
    }
  }
  searchByField(_event?: any): void {
    if (this.isSaving) return;
    const option = this.searchByForm.find(
      (field) => field.id === "searchBy",
    )?.value;
    const text = this.searchByForm.find(
      (field) => field.id === "searchText",
    )?.value;
    if (!option || !String(text ?? "").trim()) {
      this.notifier.notify(
        "warning",
        "Please select a search option and enter a search text.",
      );
      return;
    }
    this.search(String(text), option);
  }
  searchField(field: FormField): void {
    if (this.isSaving || this.isSearching) return;
    const options: Record<string, string> = {
      ContractNumber: "ContractNo",
      InvoiceNumber: "InvoiceNo",
      RegistrationNumber: "RegNo",
      NRICNumber: "NRIC",
      RefNo: "BuyerOrder",
      ChasisNumber: "ChasisNumber",
      EngineNumber: "EngineNumber",
    };
    if (String(field.value ?? "").trim())
      this.search(String(field.value), options[field.id]);
  }
  searchOnBlur(field: FormField, event: FocusEvent): void {
    if (!(event.target instanceof HTMLInputElement)) return;
    if (
      ![
        "ContractNumber",
        "RegistrationNumber",
        "EngineNumber",
        "InvoiceNumber",
        "NRICNumber",
      ].includes(field.id)
    )
      return;
    if (field.value === this.lastSearchResult?.[field.id]) return;
    this.searchField(field);
  }
  private search(text: string, option: string): void {
    const version = ++this.version;
    this.isSearching = true;
    this.paymentStatusService
      .searchPaymentStatus(option, text)
      .subscribe({
        next: (response) => {
          if (version !== this.version) return;
          this.isSearching = false;
          if (
            !this.succeeded(response) ||
            !response.body?.ContractNumber
          )
            return;
          this.lastSearchResult = JSON.parse(
            JSON.stringify(response.body),
          );
          this.synchronizeFields();
          this.filteredDataTotalAmountReceived =
            this.lastSearchResult.GvReceiptGrid || [];
          this.filteredDataChequesIssued =
            this.lastSearchResult.GvChequesGrid || [];
          this.filteredDataKomocoItems =
            this.lastSearchResult.KomocoAccessoriesGrid || [];
        },
        error: (error) => {
          if (version === this.version) {
            this.isSearching = false;
            this.reportError(error);
          }
        },
      });
  }
  private validEdits(): boolean {
    for (const fields of Object.values(this.formGroups))
      for (const field of fields || []) {
        if (field.lock || field.type === "const") continue;
        const value = field.value;
        if (
          field.type === "number" &&
          value != null &&
          value !== "" &&
          !Number.isFinite(Number(value))
        )
          return false;
        if (field.type === "date" && value) {
          const parsed = new Date(value + "T00:00:00Z");
          if (
            !Number.isFinite(parsed.getTime()) ||
            parsed.toISOString().slice(0, 10) !== value
          )
            return false;
        }
      }
    return true;
  }
  saveRecord(): void {
    if (!this.hasContract || this.busy) return;
    if (!this.validEdits()) {
      this.notifier.notify(
        "warning",
        "Please enter valid dates and amounts.",
      );
      return;
    }
    if (
      !window.confirm(
        "Are you sure to save the payment details for this contract?",
      )
    )
      return;
    const contract = this.lastSearchResult.ContractNumber;
    this.isSaving = true;
    this.paymentStatusService
      .savePaymentDetail({ model: this.buildModel() })
      .subscribe({
        next: (response) => {
          this.isSaving = false;
          if (this.succeeded(response)) {
            this.notifier.notify("success", response.message);
            this.search(contract, "ContractNo");
          }
        },
        error: (error) => {
          this.isSaving = false;
          this.reportError(error);
        },
      });
  }
  private buildPrintModel(parf: boolean): any {
    const keys = parf
      ? [
          "ContractNumber",
          "TotalRebateAmount",
          "TotalAmountReceived",
          "LoanAmount",
          "AdjustmentAmount",
          "TotalDueAmount",
          "PARFValue",
          "COERebateValue",
          "AdministrativeCharge",
          "VehiclePrice",
          "COETopUp",
          "Accessories",
          "CashDiscount",
          "CEVSSurcharge",
          "RegistrationDate",
          "InvoiceNumber",
          "InsurancePremium",
          "FirstInstallment",
          "RegistrationNumber",
          "Model",
          "ContractDate",
          "Colour",
          "VINNumber",
          "BuyerName",
          "SalesConsultant",
          "COEType",
          "CarType",
          "COERebate",
          "COEResidualRebate",
          "BalanceAmount",
          "PARFRebate",
          "OPCRebate",
          "NumberRetentionFee",
          "FinCompany",
          "Remarks",
          "ARFRebate",
          "DutyRebate",
          "TotalAmountInSalesConsultantAccount",
          "FinanceReceiptNumber",
          "FinanceReceiptDate",
          "SpotterCommission",
          "Overtrade",
        ]
      : [
          "ContractNumber",
          "TotalRebateAmount",
          "TotalAmountReceived",
          "LoanAmount",
          "AdjustmentAmount",
          "TotalDueAmount",
          "PARFValue",
          "COERebateValue",
          "AdministrativeCharge",
          "VehiclePrice",
          "COETopUp",
          "Accessories",
          "CashDiscount",
          "RoyaltyDiscount",
          "CEVSSurcharge",
          "RegistrationDate",
          "InvoiceNumber",
          "InsurancePremium",
          "FirstInstallment",
          "RegistrationNumber",
          "Model",
          "ContractDate",
          "Colour",
          "VINNumber",
          "BuyerName",
          "SalesConsultant",
          "COEType",
          "CarType",
          "COERebate",
          "COEResidualRebate",
          "BalanceAmount",
          "PARFRebate",
          "OPCRebate",
          "NumberRetentionFee",
          "FinCompany",
          "Remarks",
          "ARFRebate",
          "DutyRebate",
          "TotalAmountInSalesConsultantAccount",
          "FinanceReceiptNumber",
          "FinanceReceiptDate",
          "TotalAmountReceivedSalesConsultant",
          "SpotterCommission",
          "Overtrade",
        ];
    const model: any = {};
    for (const key of keys)
      if (
        Object.prototype.hasOwnProperty.call(
          this.lastSearchResult,
          key,
        )
      )
        model[key] = this.lastSearchResult[key];
    return model;
  }
  printPaymentStatus(): void {
    this.printReport(false);
  }
  printParfSettlement(): void {
    this.printReport(true);
  }
  private printReport(parf: boolean): void {
    if (!this.hasContract || this.busy) return;
    this.isSaving = true;
    const payload = { model: this.buildPrintModel(parf) };
    const request = parf
      ? this.paymentStatusService.printParfSettlement(payload)
      : this.paymentStatusService.printPaymentStatus(payload);
    request.subscribe({
      next: (response) => {
        this.isSaving = false;
        if (response.body?.Name)
          window.open(response.body.Name, "_blank");
        else this.reportError(response);
      },
      error: (error) => {
        this.isSaving = false;
        this.reportError(error);
      },
    });
  }
  fullDocsSumitted(): void {
    if (
      !this.hasContract ||
      this.busy ||
      !window.confirm(
        "Are you sure to update full documents for this contract?",
      )
    )
      return;
    this.isSaving = true;
    this.paymentStatusService
      .submitFullDoc(this.lastSearchResult.ContractNumber)
      .subscribe({
        next: (response) => {
          this.isSaving = false;
          if (this.succeeded(response))
            this.notifier.notify("success", response.message);
        },
        error: (error) => {
          this.isSaving = false;
          this.reportError(error);
        },
      });
  }
  private proceedToChequeIssue(field: FormField): void {
    const previous = this.lastSearchResult.ProceedToChequeIssue;
    if (!this.hasContract || field.lock || this.busy) {
      field.value = previous;
      return;
    }
    this.lastSearchResult.ProceedToChequeIssue = !!field.value;
    this.isSaving = true;
    this.paymentStatusService
      .proceedToChequeIssue(this.buildModel())
      .subscribe({
        next: (response) => {
          this.isSaving = false;
          if (this.succeeded(response))
            this.lastSearchResult.DateSubmitted =
              typeof response.body === "string" ? response.body : "";
          else this.lastSearchResult.ProceedToChequeIssue = previous;
          this.synchronizeFields();
        },
        error: (error) => {
          this.isSaving = false;
          this.lastSearchResult.ProceedToChequeIssue = previous;
          this.synchronizeFields();
          this.reportError(error);
        },
      });
  }
  toInvoice(): void {
    const contract = this.lastSearchResult?.ContractNumber;
    window.location.href =
      environment.KAPS_V1_HOME_URL +
      "invoice" +
      (contract ? "?contractno=" + encodeURIComponent(contract) : "");
  }
  clear(): void {
    if (this.isSaving) return;
    ++this.version;
    this.lastSearchResult = null;
    this.isSearching = false;
    this.selectedTab = "Balance";
    for (const fields of Object.values(this.formGroups))
      for (const field of fields || []) field.value = undefined;
    for (const field of this.searchBooking) field.value = "";
    this.searchByForm[0].value = "ContractNo";
    this.detailsTradeInVehicle.find(
      (field) => field.id === "FinCompany",
    )!.value = "NF";
    this.detailsVehicle3.find(
      (field) => field.id === "ProceedToChequeIssue",
    )!.lock = true;
    this.filteredDataTotalAmountReceived = [];
    this.filteredDataChequesIssued = [];
    this.filteredDataKomocoItems = [];
  }
}
